import { Fragment } from 'react';
import { Card, Button, CardHeader, Col, Row, CardBody } from 'reactstrap';
import Helper from '../../utilities/helper'
import { IDENTITY_CONFIG } from '../../utilities/authConstants';
import { IUserProfile } from './MyAccount';

interface IProfileProps {
    title: string,
    subtitle?: string,
    userProfile: IUserProfile,
    editHandler: () => void,
}

export const MyProfile = ({ title, subtitle, userProfile, editHandler }: IProfileProps) => {

    const handleChangePassword = () => {
        var returnUrl = window.location.href;
        window.location.href = IDENTITY_CONFIG.authority + '/account/ChangePassword?rUrl=' + returnUrl + "&clientId=" + IDENTITY_CONFIG.client_id;
    }

    //returns the address lines that have content: street line 1, street line 2, then "City, ST  ZIP"
    const formatAddress = () => {
        var stateProvinceRegion = userProfile.stateProvinceRegion !== "0" ? userProfile.stateProvinceRegion : "";
        var cityAndState = [userProfile.city, stateProvinceRegion].filter(Boolean).join(', ');
        var lastLine = [cityAndState, userProfile.postalCode].filter(Boolean).join('  ');
        return [userProfile.addressLine1, userProfile.addressLine2, lastLine].filter(Boolean);
    }

    return (
        <Card>
            <CardHeader>
                <Row>
                    <Col sm={4}>
                        <h4 className="css_heading bold mt-0">{title}</h4>
                    </Col>
                    <Col sm={8}>
                        <Button className="hollowPos blueBorder tertiaryButton iconRightArrowBlue" onClick={editHandler}>EDIT</Button>
                    </Col>
                </Row>
                {subtitle && subtitle !== "" ? (
                    <Row>
                        <Col className="subtitle">
                            {(subtitle && subtitle !== "") &&
                                <p>{subtitle}</p>
                            }
                        </Col>
                    </Row>
                ): ('') }
            </CardHeader>
            <CardBody>
                <Row>
                    <Col className="profileInfo">
                        <span className="bold" >Name:</span>&nbsp;{userProfile?.firstName || ""} {userProfile?.lastName || ""}
                    </Col>
                </Row>
                <Row>
                    <Col className="profileInfo">
                        <span className="bold">Password:</span>&nbsp;<a href="#" className={'accent-link'} onClick={handleChangePassword}>Change Password</a>
                    </Col>
                </Row>
                <Row>
                    <Col className="profileInfo">
                        <span className="bold">Job Role:</span>&nbsp;
                        {userProfile.jobRoleTypeName ? userProfile.jobRoleTypeName : ''}
                    </Col>
                </Row>
                <Row>
                    <Col className="profileInfo">
                        <span className="bold">Email:</span>&nbsp;<span className="text-long-and-wrapped">{userProfile?.userName || ""}</span>
                    </Col>
                </Row>
                <Row>
                    <Col className="profileInfo">
                        <span className="bold">Phone:</span>&nbsp;{Helper.formatAsPhone(userProfile?.phone || "")}
                    </Col>
                </Row>
                <Row>
                    <Col className="profileInfo">
                        <span className="bold">Address:</span>&nbsp;<div>{formatAddress().map((line, index) => <Fragment key={index}>{index > 0 && <br />}{line}</Fragment>)}</div>
                    </Col>
                </Row><Row>
                    <Col className="profileInfo">
                        <span className="bold  text-nowrap">Organization Name:</span>&nbsp;<span className="text-long-and-wrapped">{userProfile?.organizationName || ""}</span>
                    </Col>
                </Row>
                <Row>
                    <Col className="profileInfo">
                        <span className="bold  text-nowrap">Organization Type:</span>&nbsp;{userProfile?.organizationTypeName || ""}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <span className="bold">Participation Status:</span>&nbsp;{(!userProfile?.isParticipant || false) ? 'Not Enrolled' : 'Enrolled'}
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
};
